export default __webpack_public_path__ + "static/media/Avatar-24.813c464a.svg";